import {Injectable} from '@angular/core';
import {WebsocketService} from "../../websocket/websocket.service";
import {TableWsService} from "../../websocket/table-ws.service";

@Injectable({
  providedIn: 'root'
})
export class ClearingTradeAggregWsService extends TableWsService{

  constructor(websocketService: WebsocketService) {
    super(websocketService, 'trade-aggreg');
  }

}
